module.exports = __webpack_public_path__ + "c1c9f90be7f0cfd866273a1e2daf84c3.svg";